export default __webpack_public_path__ + "static/media/ppi-sales-map-icon-banner.a7c323b8.png";